import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      appName: 'Ocean Fishing Bissau',
      appTagline: 'Seafood Trading',
      nav: {
        dashboard: 'Dashboard',
        chartOfAccounts: 'Chart of Accounts',
        voucherEntry: 'Voucher Entry',
        crDbNotes: 'Cr/Db Notes',
        salesQuotations: 'Sales Quotations',
        salesInvoices: 'Sales Invoices',
        salesReturns: 'Sales Returns',
        purchaseInvoices: 'Purchase Invoices',
        purchaseOrders: 'Purchase Orders',
        purchaseReturns: 'Purchase Returns',
        customers: 'Customers',
        suppliers: 'Suppliers',
        inventory: 'Inventory',
        calibres: 'Calibres',
        oceanFishingTrip: 'Ocean Fishing Trip',
        exchangeRates: 'Exchange Rates',
        trialBalance: 'Trial Balance',
        generalLedger: 'General Ledger',
        journal: 'Journal',
        salesAnalytics: 'Sales Analytics',
        incomeStatement: 'Income Statement',
        importData: 'Import Data',
        settings: 'Settings',
      },
      login: {
        signIn: 'Sign In',
        subtitle: 'Enter your credentials to access the system',
        email: 'Email',
        password: 'Password',
        passwordPlaceholder: 'Enter your password',
        organization: 'Organization',
        firstTime: 'First time? Initialize demo data',
        loadDemo: 'Load Demo Data',
        signingIn: 'Signing in...',
        tagline: 'Seafood Trading & Operations',
      },
      common: {
        selectOrganization: 'Please select an organization',
        signOut: 'Sign Out',
        collapse: 'Collapse',
        language: 'Language',
        save: 'Save',
        cancel: 'Cancel',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        search: 'Search',
        allPeriods: 'All Periods',
      },
    },
  },
  fr: {
    translation: {
      appName: 'Ocean Fishing Bissau',
      appTagline: 'Commerce de Fruits de Mer',
      nav: {
        dashboard: 'Tableau de Bord',
        chartOfAccounts: 'Plan Comptable',
        voucherEntry: 'Saisie des Pièces',
        crDbNotes: 'Notes de Crédit/Débit',
        salesQuotations: 'Devis de Vente',
        salesInvoices: 'Factures de Vente',
        salesReturns: 'Retours de Vente',
        purchaseInvoices: "Factures d'Achat",
        purchaseOrders: "Bons de Commande",
        purchaseReturns: "Retours d'Achat",
        customers: 'Clients',
        suppliers: 'Fournisseurs',
        inventory: 'Inventaire',
        calibres: 'Calibres',
        oceanFishingTrip: 'Sortie de Pêche',
        exchangeRates: 'Taux de Change',
        trialBalance: 'Balance Générale',
        generalLedger: 'Grand Livre',
        journal: 'Journal',
        salesAnalytics: 'Analyses des Ventes',
        incomeStatement: 'Compte de Résultat',
        importData: 'Importer des Données',
        settings: 'Paramètres',
      },
      login: {
        signIn: 'Se Connecter',
        subtitle: 'Entrez vos identifiants pour accéder au système',
        email: 'E-mail',
        password: 'Mot de Passe',
        passwordPlaceholder: 'Entrez votre mot de passe',
        organization: 'Organisation',
        firstTime: 'Première fois ? Initialiser les données de démonstration',
        loadDemo: 'Charger les Données de Démo',
        signingIn: 'Connexion...',
        tagline: 'Commerce et Opérations de Fruits de Mer',
      },
      common: {
        selectOrganization: 'Veuillez sélectionner une organisation',
        signOut: 'Déconnexion',
        collapse: 'Réduire',
        language: 'Langue',
        save: 'Enregistrer',
        cancel: 'Annuler',
        add: 'Ajouter',
        edit: 'Modifier',
        delete: 'Supprimer',
        search: 'Rechercher',
        allPeriods: 'Toutes les Périodes',
      },
    },
  },
  pt: {
    translation: {
      appName: 'Ocean Fishing Bissau',
      appTagline: 'Comércio de Pescado',
      nav: {
        dashboard: 'Painel',
        chartOfAccounts: 'Plano de Contas',
        voucherEntry: 'Lançamento de Documentos',
        crDbNotes: 'Notas de Crédito/Débito',
        salesQuotations: 'Orçamentos de Venda',
        salesInvoices: 'Faturas de Venda',
        salesReturns: 'Devoluções de Venda',
        purchaseInvoices: 'Faturas de Compra',
        purchaseOrders: 'Ordens de Compra',
        purchaseReturns: 'Devoluções de Compra',
        customers: 'Clientes',
        suppliers: 'Fornecedores',
        inventory: 'Inventário',
        calibres: 'Calibres',
        oceanFishingTrip: 'Viagem de Pesca',
        exchangeRates: 'Taxas de Câmbio',
        trialBalance: 'Balancete',
        generalLedger: 'Livro Razão',
        journal: 'Diário',
        salesAnalytics: 'Análise de Vendas',
        incomeStatement: 'Demonstração de Resultados',
        importData: 'Importar Dados',
        settings: 'Definições',
      },
      login: {
        signIn: 'Entrar',
        subtitle: 'Insira as suas credenciais para aceder ao sistema',
        email: 'E-mail',
        password: 'Palavra-passe',
        passwordPlaceholder: 'Insira a sua palavra-passe',
        organization: 'Organização',
        firstTime: 'Primeira vez? Inicializar dados de demonstração',
        loadDemo: 'Carregar Dados de Demonstração',
        signingIn: 'A entrar...',
        tagline: 'Comércio e Operações de Pescado',
      },
      common: {
        selectOrganization: 'Por favor selecione uma organização',
        signOut: 'Terminar Sessão',
        collapse: 'Recolher',
        language: 'Idioma',
        save: 'Guardar',
        cancel: 'Cancelar',
        add: 'Adicionar',
        edit: 'Editar',
        delete: 'Eliminar',
        search: 'Pesquisar',
        allPeriods: 'Todos os Períodos',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'pt'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'ofb_language',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
